import React, { useState, useEffect } from 'react';
import { Container } from '@mui/material';
import CustomAppBar from '../../components/AppBar';
import NewWeatherWidget from '../../components/NewWeatherWidget';
import QuickLinks from '../../components/QuickLinks';
import NewsSection from '../../components/AlertsUpdates';
import getQuickLinks from '../../Data/iconsData';
import FarmViewCard from '../../components/Custom/FarmCardView';
import { useNavigate } from 'react-router-dom';
import api from '../../globals/axios';
import { useTranslation } from 'react-i18next';
import CustomCard from '../../components/Famer/GenericCard';
import FarmStepperIcon from '../../assets/Icon/FarmStepper.png';
import LoaderContainer from '../../components/LoaderContainer';

export default function FarmerHomepage() {
  const quickLinksData = getQuickLinks('farmer');
  const [farmerStatus, setFarmerStatus] = useState([]);
  const [farmData, setFarmData] = useState({});
  const [loading, setLoading] = useState(true);
  const [alerts, setAlerts] = useState([]);
  const { t } = useTranslation();

  const fetchStatus = () => {
    api
      .get('farmer/farmer-stages/')
      .then(res => {
        if (res && res.data) {
          setLoading(false);
          setFarmerStatus(res.data);
          if (res.data.latest_farmland_data) {
            setFarmData(res.data.latest_farmland_data);
          }
        }
      })
      .catch(err => {
        console.error('Error fetching farmer status:', err);
        setLoading(false);
      });
  };

  const fetchAlertUpdates = async () => {
    try {
      const response = await api.get('/common/alert-updates/');
      setAlerts(response.data);
    } catch (error) {
      console.log('Error Fetching Tutorials list:', error);
    }
  };

  useEffect(() => {
    fetchStatus();
    fetchAlertUpdates();
  }, []);

  const navigate = useNavigate();
  const handleViewFarmClick = () => {
    navigate('/farmer/farms');
  };

  const handleView = () => {
    navigate(`/farmer/farms`);
  };

  return (
    <div>
      <CustomAppBar />
      <Container maxWidth="xs" style={{ marginTop: 20 }}>
        <NewWeatherWidget />
        {/* {farmData && Object.keys(farmData).length > 0 && (
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <CustomTitleLabel>
                {t("My Farm :")} {farmData?.farmland_name}
              </CustomTitleLabel>
            </Grid>
            <Grid item xs={3}>
              {renderStageLink(farmerStatus)}
            </Grid>
          </Grid>
        )} */}
        <LoaderContainer loading={loading}>
          {farmerStatus &&
          farmerStatus.stages &&
          farmerStatus.stages.find(
            stage =>
              stage.stage_name === 'Complete Farmer Process' && stage.complete
          ) ? (
            <div
              style={{
                textAlign: 'center',
                margin: 'auto',
                width: '100%',
                marginTop: '10px',
              }}
              onClick={handleView}
            >
              <CustomCard
                id={farmData?.farmland_id}
                t={t}
                data={{
                  [t('Farm name')]: farmData?.farmland_name,
                  [t('Farm Area')]: farmData?.farm_area,
                }}
                file={FarmStepperIcon}
                loanData={true}
                handlePrimaryButton={handleView}
                image_size={true}
              />
            </div>
          ) : (
            <div onClick={handleView}>
              <FarmViewCard
                onClick={handleViewFarmClick}
                farmerStatus={farmerStatus}
                t={t}
              />
            </div>
          )}
        </LoaderContainer>
        <QuickLinks data={quickLinksData} farmerStatus={farmerStatus} />
      </Container>
      <Container
        maxWidth="xs"
        sx={{
          marginBottom: '60px',
          padding: '0px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <NewsSection images={alerts} />
      </Container>
    </div>
  );
}
